export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink border-t border-white/10 pt-20 pb-10 grain overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-5">
            <span className="data-label text-gold">/ Axiom Property Advisory</span>
            <p className="mt-6 font-display text-3xl sm:text-4xl leading-tight text-white/80 max-w-md">
              Straightforward, reliable property advice
              <br />
              <span className="text-gold italic">— always in plain English.</span>
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <div className="data-label mb-5">/ Browse</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="#how-we-think" className="hover:text-gold transition-colors">How It Works</a></li>
              <li><a href="#process" className="hover:text-gold transition-colors">Our Process</a></li>
              <li><a href="#pricing" className="hover:text-gold transition-colors">Pricing</a></li>
              <li><a href="#faq" className="hover:text-gold transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="data-label mb-5">/ Contact</div>
            <ul className="space-y-3 text-white/70 text-sm font-mono tracking-wider">
              <li>hello@axiompropertyadvisory.com.au</li>
              <li>1300 713 180</li>
              <li>Australia wide</li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="relative -mx-6 sm:-mx-12 lg:-mx-16 select-none">
          <div className="font-display text-[22vw] leading-[0.85] tracking-tighter text-white/[0.04] text-center">
            AXIOM
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
          <span>© {new Date().getFullYear()} Axiom Property Advisory. All rights reserved.</span>
          <span className="flex items-center gap-4">
            <a href="/terms" data-testid="footer-link-privacy" className="hover:text-gold">Privacy</a>
            <span>·</span>
            <a href="/terms" data-testid="footer-link-terms" className="hover:text-gold">Terms &amp; Conditions</a>
            <span>·</span>
            <a href="/terms" data-testid="footer-link-disclosures" className="hover:text-gold">Disclosures</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
